import { Pipe, PipeTransform } from '@angular/core';

export enum SendByType {
	EXPERT = 1,
	CUSTOMER = 2
}

export namespace SendByType {

	export function getTitle(type: SendByType): string {
		return Object.keys(SendByType).find(key => SendByType[key] === type);
	}

}

@Pipe({
	name: 'sendByTypeText',
	standalone: true
})
export class SendByTypePipe implements PipeTransform {

	sendByType = SendByType;

	transform(value: SendByType): any {
		return this.sendByType.getTitle(value);
	}
}
